var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    viewBox: "0 0 23.616 13.503"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,20.679l8.93-8.937a1.681,1.681,0,0,1,2.384,0,1.7,1.7,0,0,1,0,2.391L19.2,24.258a1.685,1.685,0,0,1-2.327.049L6.68,14.14a1.688,1.688,0,0,1,2.384-2.391Z",
    transform: "translate(-6.188 -11.246)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "attach-icon",
    viewBox: "0 0 17 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,13.5V8A4,4,0,0,0,6,8v5.5a6.5,6.5,0,1,0,13,0V4h2v9.5a8.5,8.5,0,0,1-17,0V8A6,6,0,0,1,16,8v5.5a3.5,3.5,0,1,1-7,0V8h2v5.5a1.5,1.5,0,0,0,3,0Z",
    transform: "translate(-4 -2)",
    fill: "#c0c9ea"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "search-icon",
    viewBox: "0 0 21.687 26.848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_400131_document_find_scan_search_search_documents_icon_copy_2",
    "data-name": "400131_document_find_scan_search_search documents_icon copy 2",
    transform: "translate(-0.442 -0.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.34 0.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.027,0H1.225A1.285,1.285,0,0,0,0,1.4V24.806a1.285,1.285,0,0,0,1.225,1.4H18.477a1.285,1.285,0,0,0,1.225-1.4V3.743Z",
    transform: "translate(0.102 0.17)",
    fill: "#4a90e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.293,3.743H3.709L0,0V2.45A1.251,1.251,0,0,0,1.293,3.743Z",
    transform: "translate(16.129 0.17)",
    fill: "#b1e1f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M5.921,6.6H.681A.683.683,0,0,1,0,5.921V.681A.683.683,0,0,1,.681,0h5.24A.683.683,0,0,1,6.6.681v5.24A.683.683,0,0,1,5.921,6.6Z",
    transform: "translate(2.892 3.485)",
    fill: "#fbb116"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(2.722 6.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M9.153.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H9.153A.465.465,0,0,1,9.63.476h0A.465.465,0,0,1,9.153.953Z",
    transform: "translate(0.17 7.69)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M7.214.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H7.214A.465.465,0,0,1,7.69.476h0A.487.487,0,0,1,7.214.953Z",
    transform: "translate(0.17 10.617)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M7.622.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H7.622A.465.465,0,0,1,8.1.476h0A.465.465,0,0,1,7.622.953Z",
    transform: "translate(0.17 13.509)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M5.887.953H.442A.45.45,0,0,1,0,.51V.442A.45.45,0,0,1,.442,0h5.41A.45.45,0,0,1,6.3.442V.51A.422.422,0,0,1,5.887.953Z",
    transform: "translate(8.949 0.136)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M5.887.953H.442A.45.45,0,0,1,0,.51V.442A.45.45,0,0,1,.442,0h5.41A.45.45,0,0,1,6.3.442V.51A.422.422,0,0,1,5.887.953Z",
    transform: "translate(8.949 2.96)",
    fill: "#a0bec7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M0,1.837H5.206A.915.915,0,0,0,6.125.919h0A.915.915,0,0,0,5.206,0H0Z",
    transform: "translate(10.583 16.28)",
    fill: "#778b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(6.188 11.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M6.1,7.637a1.489,1.489,0,0,1-1.089-.442L.181,2.329c-.612-.613.476-.51,1.055-1.089C1.849.627,1.747-.428,2.325.185L7.157,5.017a1.52,1.52,0,0,1,0,2.178A1.493,1.493,0,0,1,6.1,7.637Z",
    transform: "translate(8.326 8.152)",
    fill: "#3d4652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M1.429,3.573,0,2.178,2.178,0l1.4,1.4A4.938,4.938,0,0,1,2.688,2.62,5.071,5.071,0,0,1,1.429,3.573Z",
    transform: "translate(8.881 8.711)",
    fill: "#ed4589"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.968,
    cy: 4.968,
    r: 4.968,
    transform: "translate(1.157 0.987)",
    fill: "#e1efdb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,5.819a5.819,5.819,0,1,1,5.819,5.819A5.838,5.838,0,0,1,0,5.819Z",
    transform: "translate(0.306 0.136)",
    fill: "#3d4652"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "calendar-icon",
    viewBox: "0 0 21.607 22.107"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1557.196 -258.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 21.607,
    height: 0.786,
    transform: "translate(1557.196 264.814)",
    fill: "#ebf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,14.457a.746.746,0,0,0,.746.746H20.861a.746.746,0,0,0,.746-.746V0H0Z",
    transform: "translate(1557.196 265.6)",
    fill: "#4a90e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M21.607.746A.746.746,0,0,0,20.861,0H.746A.746.746,0,0,0,0,.746V3.614H21.607Z",
    transform: "translate(1557.196 261.161)",
    fill: "#e56353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M1.179.589V0H.314L0,.589Z",
    transform: "translate(1569.571 273.182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M814.536,443.457v-2.985a.478.478,0,0,1,.472-.472.452.452,0,0,1,.471.472v2.985a.471.471,0,1,1-.942,0Zm-2,0v-2.985A.477.477,0,0,1,813,440a.453.453,0,0,1,.472.472v2.985a.471.471,0,1,1-.942,0Zm-10.529,0v-2.985a.472.472,0,1,1,.943,0v2.985a.472.472,0,1,1-.943,0Zm-2,0v-2.985a.472.472,0,1,1,.943,0v2.985a.472.472,0,1,1-.943,0Z",
    transform: "translate(760.261 -180.804)",
    fill: "#64798a",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1563.286 268.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,0V9.114A4.56,4.56,0,0,0,4.557,4.557,4.56,4.56,0,0,0,0,0Z",
    transform: "translate(4.714 0.196)",
    fill: "#3ea69b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M0,4.557A4.56,4.56,0,0,0,4.557,9.114V0A4.56,4.56,0,0,0,0,4.557Z",
    transform: "translate(0.157 0.196)",
    fill: "#44c4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(1.571 2.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M1.8,4.2H1.722a.683.683,0,0,1-.432-.236L.111,2.319a.61.61,0,0,1,.118-.825.61.61,0,0,1,.825.118l.786,1.1L4.59.158A.57.57,0,0,1,5.415.2a.57.57,0,0,1-.039.825L2.115,4.008A.294.294,0,0,1,1.8,4.2Z",
    transform: "translate(0.321 0.431)",
    fill: "#31978c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M1.8,4.2H1.722a.683.683,0,0,1-.432-.236L.111,2.319a.61.61,0,0,1,.118-.825.61.61,0,0,1,.825.118l.786,1.1L4.59.158A.57.57,0,0,1,5.415.2a.57.57,0,0,1-.039.825L2.115,4.008A.35.35,0,0,1,1.8,4.2Z",
    transform: "translate(0.321 0.156)",
    fill: "#fff"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "search-icon",
    viewBox: "0 0 21.687 26.848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_400131_document_find_scan_search_search_documents_icon_copy_2",
    "data-name": "400131_document_find_scan_search_search documents_icon copy 2",
    transform: "translate(-0.442 -0.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.34 0.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.027,0H1.225A1.285,1.285,0,0,0,0,1.4V24.806a1.285,1.285,0,0,0,1.225,1.4H18.477a1.285,1.285,0,0,0,1.225-1.4V3.743Z",
    transform: "translate(0.102 0.17)",
    fill: "#4a90e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.293,3.743H3.709L0,0V2.45A1.251,1.251,0,0,0,1.293,3.743Z",
    transform: "translate(16.129 0.17)",
    fill: "#b1e1f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M5.921,6.6H.681A.683.683,0,0,1,0,5.921V.681A.683.683,0,0,1,.681,0h5.24A.683.683,0,0,1,6.6.681v5.24A.683.683,0,0,1,5.921,6.6Z",
    transform: "translate(2.892 3.485)",
    fill: "#fbb116"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(2.722 6.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M9.153.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H9.153A.465.465,0,0,1,9.63.476h0A.465.465,0,0,1,9.153.953Z",
    transform: "translate(0.17 7.69)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M7.214.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H7.214A.465.465,0,0,1,7.69.476h0A.487.487,0,0,1,7.214.953Z",
    transform: "translate(0.17 10.617)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M7.622.953H.476A.465.465,0,0,1,0,.476H0A.465.465,0,0,1,.476,0H7.622A.465.465,0,0,1,8.1.476h0A.465.465,0,0,1,7.622.953Z",
    transform: "translate(0.17 13.509)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M5.887.953H.442A.45.45,0,0,1,0,.51V.442A.45.45,0,0,1,.442,0h5.41A.45.45,0,0,1,6.3.442V.51A.422.422,0,0,1,5.887.953Z",
    transform: "translate(8.949 0.136)",
    fill: "#a0bec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M5.887.953H.442A.45.45,0,0,1,0,.51V.442A.45.45,0,0,1,.442,0h5.41A.45.45,0,0,1,6.3.442V.51A.422.422,0,0,1,5.887.953Z",
    transform: "translate(8.949 2.96)",
    fill: "#a0bec7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M0,1.837H5.206A.915.915,0,0,0,6.125.919h0A.915.915,0,0,0,5.206,0H0Z",
    transform: "translate(10.583 16.28)",
    fill: "#778b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(6.188 11.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M6.1,7.637a1.489,1.489,0,0,1-1.089-.442L.181,2.329c-.612-.613.476-.51,1.055-1.089C1.849.627,1.747-.428,2.325.185L7.157,5.017a1.52,1.52,0,0,1,0,2.178A1.493,1.493,0,0,1,6.1,7.637Z",
    transform: "translate(8.326 8.152)",
    fill: "#3d4652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M1.429,3.573,0,2.178,2.178,0l1.4,1.4A4.938,4.938,0,0,1,2.688,2.62,5.071,5.071,0,0,1,1.429,3.573Z",
    transform: "translate(8.881 8.711)",
    fill: "#ed4589"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.968,
    cy: 4.968,
    r: 4.968,
    transform: "translate(1.157 0.987)",
    fill: "#e1efdb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,5.819a5.819,5.819,0,1,1,5.819,5.819A5.838,5.838,0,0,1,0,5.819Z",
    transform: "translate(0.306 0.136)",
    fill: "#3d4652"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "select-arrow",
    viewBox: "0 0 19.124 12.357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12603,1225.31h19.124l-9.514,12.357Z",
    transform: "translate(-12603 -1225.31)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    viewBox: "0 0 34.362 35.544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,35.544a1.5,1.5,0,1,1,0-3H32.862a1.5,1.5,0,1,1,0,3Zm1.506-5.377a1.5,1.5,0,0,1-.5-1.217l.5-8a1.5,1.5,0,0,1,.436-.967L22.19,1.233a1.512,1.512,0,0,1,.2-.166A5.11,5.11,0,0,1,25.35,0c1.748,0,3.047,1.13,4.3,2.222l.209.182a7.538,7.538,0,0,1,2.886,4.984,3.233,3.233,0,0,1-.938,2.467L13.061,28.6a1.5,1.5,0,0,1-.7.394l-.136.034-.089.019L4.275,30.518a1.5,1.5,0,0,1-1.269-.351ZM5.962,21.7l-.345,5.513,5.64-1.052L24.939,12.484,20.06,7.605Zm21.1-11.341,2.629-2.629c.025-.025.067-.068.061-.239A4.975,4.975,0,0,0,27.9,4.671l-.212-.184C26.768,3.689,25.976,3,25.35,3a2.191,2.191,0,0,0-1.137.451L22.181,5.484Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    viewBox: "0 0 15.001 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-953 -533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(953 533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M12.22,0a2.761,2.761,0,0,0-1.965.813L5.219,5.853A4.565,4.565,0,0,0,3.871,9.1v2.025H5.9A4.565,4.565,0,0,0,9.145,9.782l5.042-5.037A2.78,2.78,0,0,0,12.221,0Zm.939,3.716L8.122,8.756A3.125,3.125,0,0,1,5.9,9.678H5.323V9.1a3.125,3.125,0,0,1,.922-2.223l5.04-5.04a1.328,1.328,0,0,1,1.877,1.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2.661,15h8.71a2.661,2.661,0,0,0,2.661-2.661V8.467H12.581v3.871a1.21,1.21,0,0,1-1.21,1.21H2.661a1.209,1.209,0,0,1-1.21-1.21V3.629a1.21,1.21,0,0,1,1.21-1.21H6.532V.968H2.661A2.661,2.661,0,0,0,0,3.629v8.71A2.661,2.661,0,0,0,2.661,15Z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "file-attached",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3186 7.47324C17.2022 7.35646 17.044 7.29079 16.8791 7.29079C16.714 7.29079 16.5559 7.35646 16.4393 7.47324L8.80142 15.1134C7.80969 16.1051 6.36434 16.4924 5.00978 16.1294C3.65505 15.7664 2.59696 14.7083 2.23396 13.3537C1.87097 11.999 2.25821 10.5536 3.24995 9.56209L10.8409 1.96852C11.4558 1.35363 12.352 1.11349 13.1922 1.33855C14.0323 1.56362 14.6885 2.21975 14.9136 3.05992C15.1386 3.89991 14.8985 4.79633 14.2834 5.41127L6.7351 12.9623C6.56756 13.1459 6.33209 13.2532 6.08348 13.2587C5.83485 13.2641 5.59469 13.1676 5.41918 12.9914C5.24366 12.8152 5.14802 12.5747 5.15443 12.326C5.16101 12.0774 5.26895 11.8423 5.45348 11.6754L12.9672 4.16171C13.1644 3.91325 13.1425 3.55618 12.9168 3.33351C12.6909 3.11088 12.3336 3.09424 12.0879 3.29488L4.57194 10.7989C4.15628 11.1996 3.91926 11.7508 3.91424 12.3281C3.90923 12.9054 4.13636 13.4607 4.54475 13.8687C4.9533 14.2767 5.50858 14.5035 6.08591 14.498C6.66323 14.4925 7.21421 14.2551 7.6146 13.8391L15.1629 6.29079C15.8591 5.60276 16.2521 4.66558 16.255 3.68702C16.2579 2.70828 15.8703 1.76885 15.1784 1.07664C14.4862 0.384617 13.5468 -0.00277935 12.5682 1.50129e-05C11.5894 0.00296049 10.6522 0.395918 9.96421 1.09208L2.37109 8.68299C1.39147 9.64944 0.837917 10.9667 0.833038 12.343C0.82836 13.719 1.37275 15.0402 2.34563 16.0135C3.31851 16.9867 4.63962 17.5317 6.01565 17.5273C7.39185 17.523 8.70932 16.9698 9.67613 15.9905L17.3189 8.35258C17.4357 8.23615 17.5014 8.07797 17.5014 7.91285C17.5014 7.7479 17.4357 7.58971 17.3189 7.47328L17.3186 7.47324Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "qr-icon",
    viewBox: "0 0 35 16.848"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.188,16.66a.677.677,0,0,1,.057-.989l1.872-1.592a.832.832,0,0,1,.568-.247,2.964,2.964,0,1,1,.331.331.835.835,0,0,1-.246.568L25.177,16.6a.719.719,0,0,1-.533.245A.639.639,0,0,1,24.188,16.66Zm2.776-4.751A1.976,1.976,0,1,0,28.94,9.932,1.976,1.976,0,0,0,26.964,11.909ZM33.735,10.9V0H35V10.9ZM0,10.9V0H1.265V10.9Zm32.468-.008V0h.644V10.892Zm-9.1,0V0h1.265V10.892Zm-2.532,0V0H22.1V10.892Zm-5.665,0V0h.623V10.892Zm-1.266,0V0h.623V10.892Zm-1.265,0V0h.623V10.892Zm-10.748,0V0h.643V10.892Zm15.79-2V0h1.265V8.892Zm12.279-1V0h1.888V7.892Zm-2.174,0V0h1.265V7.892Zm-1.889,0V0h1.266V7.892Zm-16.412,0V0h1.246V7.892Zm-2.532,0V0h.623V7.892Zm-3.154,0V0H4.42V7.892Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    viewBox: "0 0 30.849 30.849"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6,1.928A4.82,4.82,0,0,1,32.455,9.64l-1.928,1.928L23.779,4.82l1.928-1.928A4.8,4.8,0,0,1,28.6,1.928ZM4.5,24.1,2.571,32.777l8.676-1.928L29.081,13.014,22.333,6.266ZM24.128,12.881l-13.5,13.5L8.97,24.716l13.5-13.5,1.662,1.662Z",
    transform: "translate(-2.571 -1.928)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "close",
    viewBox: "0 0 13.426 13.423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z",
    transform: "translate(-11.285 -11.289)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    viewBox: "0 0 31.5 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,32.625A3.375,3.375,0,0,0,5.625,36h20.25a3.375,3.375,0,0,0,3.375-3.375V9h-27Zm19.125-18a1.125,1.125,0,0,1,2.25,0v15.75a1.125,1.125,0,0,1-2.25,0Zm-6.75,0a1.125,1.125,0,0,1,2.25,0v15.75a1.125,1.125,0,0,1-2.25,0Zm-6.75,0a1.125,1.125,0,0,1,2.25,0v15.75a1.125,1.125,0,0,1-2.25,0ZM30.375,2.25H21.938L21.277.935A1.688,1.688,0,0,0,19.765,0H11.728a1.668,1.668,0,0,0-1.5.935L9.563,2.25H1.125A1.125,1.125,0,0,0,0,3.375v2.25A1.125,1.125,0,0,0,1.125,6.75h29.25A1.125,1.125,0,0,0,31.5,5.625V3.375A1.125,1.125,0,0,0,30.375,2.25Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "email",
    viewBox: "0 0 26 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.115,18,9.94,11.328l2.639,1.993a.7.7,0,0,0,.855-.008l2.627-1.984L24.885,18Zm16.071-7.523L26,3.815V17.138ZM0,3.814l8.814,6.662L0,17.137ZM10.373,8.951l-.019-.016L0,1.112V0H26V1.112L15.644,8.94l-.014.008L13,10.938Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    viewBox: "0 0 19 26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.839,26A1.828,1.828,0,0,1,0,24.186V9.674A1.827,1.827,0,0,1,1.839,7.861H17.161A1.827,1.827,0,0,1,19,9.674V24.186A1.828,1.828,0,0,1,17.161,26ZM5.823,15.721a3.623,3.623,0,0,0,1.839,3.141v2.3a.61.61,0,0,0,.613.6h2.452a.611.611,0,0,0,.613-.6v-2.3a3.644,3.644,0,1,0-5.516-3.141Zm3.064,4.837V18.491a.6.6,0,0,0-.368-.554,2.452,2.452,0,1,1,1.961,0,.6.6,0,0,0-.367.554v2.067ZM12.355,6.651V1.814a.611.611,0,0,0-.613-.6h-4.9a.61.61,0,0,0-.613.6V6.651H5V1.814A1.828,1.828,0,0,1,6.839,0h4.9a1.828,1.828,0,0,1,1.839,1.814V6.651Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "file",
    viewBox: "0 0 17 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53915 0.00015237V4.66415C6.53915 5.76057 5.65321 6.66415 4.57819 6.66415H0V17.9975C0 19.0939 0.889716 20 1.96477 20H15.0352C16.1102 20 17 19.0939 17 17.9975V1.99749C17 0.901067 16.1104 0.000152381 15.0352 0L6.53915 0.00015237ZM5.23184 0.388267L0.385469 5.33112H4.57819C4.95156 5.33112 5.23184 5.04526 5.23184 4.66446V0.388267ZM7.19527 9.33112H11.1135C12.1886 9.33112 13.077 10.232 13.077 11.3285C13.077 12.425 12.1886 13.3325 11.1135 13.3325H7.19527C6.32292 13.3325 6.32292 11.9978 7.19527 11.9978H11.1135C11.487 11.9978 11.7697 11.7094 11.7697 11.3285C11.7697 10.9477 11.487 10.6645 11.1135 10.6645H7.19527C6.09762 10.6645 5.2305 11.5423 5.2305 12.6618C5.2305 13.7814 6.09762 14.6658 7.19527 14.6658H11.1135C12.0048 14.6454 12.0048 16.0195 11.1135 15.9991H7.19527C5.39597 15.9991 3.92319 14.497 3.92319 12.6618C3.92319 10.8267 5.39597 9.33112 7.19527 9.33112Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down2",
    viewBox: "0 0 9 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,9.657a.716.716,0,0,0-1.075,0,.813.813,0,0,0,0,1.133l3.761,3.967a.716.716,0,0,0,1.075,0L8.827,10.79a1.016,1.016,0,0,0,0-1.133.8.8,0,0,0-1.151,0L5.3,12.248V.809A.849.849,0,0,0,4.529,0a.792.792,0,0,0-.768.809V12.248Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "info",
    viewBox: "0 0 33 33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.077,31.7A16.542,16.542,0,1,1,16.5,33,16.43,16.43,0,0,1,10.077,31.7ZM3,16.5A13.5,13.5,0,1,0,16.5,3,13.515,13.515,0,0,0,3,16.5Zm11.588,6v-6a1.5,1.5,0,0,1,3,0v6a1.5,1.5,0,1,1-3,0Zm0-12.225a1.75,1.75,0,1,1,1.75,1.75A1.751,1.751,0,0,1,14.587,10.275Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "search",
    viewBox: "0 0 12 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4202 11.2816L8.96062 8.69907C9.78921 7.64671 10.2002 6.29979 10.1082 4.93777C10.0163 3.57575 9.42849 2.30317 8.46681 1.38405C7.50512 0.464927 6.24336 -0.0301853 4.94329 0.00142561C3.64322 0.0330365 2.40464 0.588945 1.48451 1.55382C0.564373 2.5187 0.0333191 3.81849 0.00151526 5.18351C-0.0302886 6.54854 0.439591 7.87404 1.31369 8.885C2.18779 9.89597 3.399 10.5148 4.69604 10.6131C5.99308 10.7115 7.27639 10.2817 8.27973 9.41307L10.7393 11.9956C10.8296 12.0904 10.952 12.1437 11.0797 12.1437C11.2074 12.1437 11.3299 12.0904 11.4202 11.9956C11.5105 11.9008 11.5612 11.7722 11.5612 11.6381C11.5612 11.5041 11.5105 11.3755 11.4202 11.2807V11.2816ZM0.975731 5.32321C0.974729 4.32843 1.30232 3.36407 1.90268 2.59452C2.50303 1.82496 3.33899 1.29783 4.26805 1.10299C5.19711 0.908153 6.16176 1.05766 6.99759 1.52602C7.83343 1.99438 8.48869 2.75261 8.85171 3.67147C9.21472 4.59033 9.263 5.61294 8.98833 6.56499C8.71366 7.51705 8.13304 8.33962 7.34543 8.8925C6.55782 9.44537 5.61198 9.69434 4.66912 9.59695C3.72626 9.49955 2.84475 9.06184 2.17484 8.35841C1.79495 7.95994 1.49354 7.48681 1.2878 6.96603C1.08205 6.44525 0.976009 5.88702 0.975731 5.32321Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    viewBox: "0 0 18.84 21.499"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.078a9.409,9.409,0,0,1,1.59-5.24.75.75,0,1,1,1.249.83A7.924,7.924,0,1,0,9.42,4.148a9.119,9.119,0,0,0-2.67.39.758.758,0,0,1-.735-.168l-.165.189a.744.744,0,0,1-1.05.08.749.749,0,0,1-.08-1.06L7.61.258A.747.747,0,0,1,8.67.188a.756.756,0,0,1,.07,1.06L7.35,2.84a10.713,10.713,0,0,1,2.07-.2A9.43,9.43,0,1,1,0,12.078Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "scan",
    viewBox: "0 0 29.25 27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.39,27a.985.985,0,0,1,0-1.969h4.2a2.861,2.861,0,0,0,2.686-2.686v-4.2a.985.985,0,0,1,1.969,0v4.135A4.731,4.731,0,0,1,24.525,27ZM4.655,27A4.66,4.66,0,0,1,0,22.345v-4.2a.985.985,0,1,1,1.969,0v4.2a2.7,2.7,0,0,0,.823,1.842,2.682,2.682,0,0,0,1.863.843h4.2A.985.985,0,0,1,8.86,27ZM19,22.5a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2Zm-.7-6v4a.7.7,0,0,0,.7.7h4a.7.7,0,0,0,.7-.7v-4a.7.7,0,0,0-.7-.7H19A.7.7,0,0,0,18.3,16.5ZM7,22.5a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2Zm-.7-6v4a.7.7,0,0,0,.7.7h4a.7.7,0,0,0,.7-.7v-4a.7.7,0,0,0-.7-.7H7A.7.7,0,0,0,6.3,16.5Zm12.7-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2Zm-.7-6v4a.7.7,0,0,0,.7.7h4a.7.7,0,0,0,.7-.7v-4a.7.7,0,0,0-.7-.7H19A.7.7,0,0,0,18.3,6.5ZM7,12.5a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2Zm-.7-6v4a.7.7,0,0,0,.7.7h4a.7.7,0,0,0,.7-.7v-4a.7.7,0,0,0-.7-.7H7A.7.7,0,0,0,6.3,6.5ZM27.281,8.86v-4.2a2.7,2.7,0,0,0-.823-1.842A2.683,2.683,0,0,0,24.6,1.968h-4.2A.984.984,0,1,1,20.39,0h4.2A4.66,4.66,0,0,1,29.25,4.655v4.2a.985.985,0,0,1-1.969,0ZM0,8.86V4.725A4.727,4.727,0,0,1,4.725,0H8.86a.985.985,0,0,1,0,1.969h-4.2a2.68,2.68,0,0,0-1.863.843,2.7,2.7,0,0,0-.823,1.842v4.2A.984.984,0,0,1,0,8.86Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "filter-clear",
    viewBox: "0 0 39.339 32.384"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.236,32.278l-6-3a.993.993,0,0,1-.554-.895V18.941l-1.021-1.208,1.76-1.017,1.025,1.212a1.007,1.007,0,0,1,.237.646v9.192l4,2V18.574a1,1,0,0,1,.237-.646l7.249-8.572L32.286,6.4l-10.6,12.538V31.384a1,1,0,0,1-.474.851.993.993,0,0,1-.526.149A1,1,0,0,1,20.236,32.278ZM.141,22.947a1,1,0,0,1,.347-1.371L37.826.141A1,1,0,1,1,38.85,1.859L1.512,23.295a1,1,0,0,1-1.371-.347ZM.237,2.03A1,1,0,0,1,1,.384H31a1,1,0,0,1,.764,1.646L30.6,3.4,25.485,6.357l3.36-3.973H3.155l9.583,11.332-1.76,1.016Z",
    transform: "translate(0 0)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    viewBox: "0 0 13 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 6.83317H0.666748V5.1665H5.66675V0.166504H7.33342V5.1665H12.3334V6.83317H7.33342V11.8332H5.66675V6.83317Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "info-icon",
    viewBox: "0 0 20 21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H11V9.5H9V15.5ZM10 7.5C10.2833 7.5 10.5208 7.40417 10.7125 7.2125C10.9042 7.02083 11 6.78333 11 6.5C11 6.21667 10.9042 5.97917 10.7125 5.7875C10.5208 5.59583 10.2833 5.5 10 5.5C9.71667 5.5 9.47917 5.59583 9.2875 5.7875C9.09583 5.97917 9 6.21667 9 6.5C9 6.78333 9.09583 7.02083 9.2875 7.2125C9.47917 7.40417 9.71667 7.5 10 7.5ZM10 20.5C8.61667 20.5 7.31667 20.2375 6.1 19.7125C4.88333 19.1875 3.825 18.475 2.925 17.575C2.025 16.675 1.3125 15.6167 0.7875 14.4C0.2625 13.1833 0 11.8833 0 10.5C0 9.11667 0.2625 7.81667 0.7875 6.6C1.3125 5.38333 2.025 4.325 2.925 3.425C3.825 2.525 4.88333 1.8125 6.1 1.2875C7.31667 0.7625 8.61667 0.5 10 0.5C11.3833 0.5 12.6833 0.7625 13.9 1.2875C15.1167 1.8125 16.175 2.525 17.075 3.425C17.975 4.325 18.6875 5.38333 19.2125 6.6C19.7375 7.81667 20 9.11667 20 10.5C20 11.8833 19.7375 13.1833 19.2125 14.4C18.6875 15.6167 17.975 16.675 17.075 17.575C16.175 18.475 15.1167 19.1875 13.9 19.7125C12.6833 20.2375 11.3833 20.5 10 20.5ZM10 18.5C12.2333 18.5 14.125 17.725 15.675 16.175C17.225 14.625 18 12.7333 18 10.5C18 8.26667 17.225 6.375 15.675 4.825C14.125 3.275 12.2333 2.5 10 2.5C7.76667 2.5 5.875 3.275 4.325 4.825C2.775 6.375 2 8.26667 2 10.5C2 12.7333 2.775 14.625 4.325 16.175C5.875 17.725 7.76667 18.5 10 18.5Z",
    fill: "#0CA080"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    viewBox: "0 0 18 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2.25,17.033a2.95,2.95,0,0,0,.879,2.1A3.017,3.017,0,0,0,5.25,20h7.5a3.017,3.017,0,0,0,2.121-.869,2.95,2.95,0,0,0,.879-2.1V5.166h1.5a.752.752,0,0,0,.65-.371.735.735,0,0,0,0-.742.752.752,0,0,0-.65-.371H13.432A4.455,4.455,0,0,0,11.021.474a4.545,4.545,0,0,0-4.042,0A4.456,4.456,0,0,0,4.567,3.682H.75a.752.752,0,0,0-.65.371.735.735,0,0,0,0,.742.752.752,0,0,0,.65.371h1.5ZM9,1.457a3.021,3.021,0,0,1,1.836.622,2.966,2.966,0,0,1,1.067,1.6H6.1a2.966,2.966,0,0,1,1.067-1.6A3.022,3.022,0,0,1,9,1.457ZM5.25,5.166h9V17.033a1.475,1.475,0,0,1-.439,1.049,1.509,1.509,0,0,1-1.061.434H5.25a1.509,1.509,0,0,1-1.061-.434,1.476,1.476,0,0,1-.439-1.049V5.166ZM6,15.55V8.133a.74.74,0,0,1,.375-.642.757.757,0,0,1,.75,0,.74.74,0,0,1,.375.642V15.55a.74.74,0,0,1-.375.642.758.758,0,0,1-.75,0A.74.74,0,0,1,6,15.55Zm4.5,0V8.133a.74.74,0,0,1,.375-.642.757.757,0,0,1,.75,0A.74.74,0,0,1,12,8.133V15.55a.74.74,0,0,1-.375.642.758.758,0,0,1-.75,0A.74.74,0,0,1,10.5,15.55Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "qr-icons",
    viewBox: "0 0 20 17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18802 16.66C9.12379 16.5928 9.07407 16.5132 9.04196 16.426C9.00985 16.3388 8.99604 16.2459 9.00138 16.1531C9.00673 16.0603 9.03112 15.9696 9.07304 15.8867C9.11495 15.8038 9.1735 15.7303 9.24502 15.671L11.117 14.079C11.2675 13.9266 11.471 13.8382 11.685 13.832C11.188 13.2494 10.9357 12.497 10.981 11.7326C11.0264 10.9681 11.3659 10.2508 11.9284 9.73114C12.4909 9.21144 13.2327 8.92963 13.9984 8.94476C14.7641 8.95989 15.4942 9.2708 16.0357 9.81232C16.5772 10.3538 16.8881 11.0839 16.9033 11.8496C16.9184 12.6153 16.6366 13.3571 16.1169 13.9196C15.5972 14.4821 14.8799 14.8216 14.1155 14.867C13.351 14.9123 12.5986 14.6601 12.016 14.163C12.0098 14.3769 11.9218 14.5802 11.77 14.731L10.177 16.6C10.1104 16.676 10.0285 16.7371 9.93664 16.7793C9.8448 16.8215 9.74509 16.8439 9.64402 16.845C9.55956 16.8458 9.47577 16.8299 9.3975 16.7982C9.31923 16.7664 9.24803 16.7194 9.18802 16.66ZM11.964 11.909C11.9642 12.2998 12.0803 12.6817 12.2975 13.0065C12.5148 13.3314 12.8234 13.5845 13.1845 13.7339C13.5456 13.8833 13.9429 13.9223 14.3261 13.8459C14.7094 13.7696 15.0614 13.5813 15.3376 13.3049C15.6139 13.0285 15.802 12.6764 15.8781 12.2931C15.9543 11.9099 15.9151 11.5126 15.7655 11.1516C15.6159 10.7906 15.3627 10.482 15.0377 10.2649C14.7128 10.0479 14.3308 9.932 13.94 9.932C13.6804 9.932 13.4234 9.98314 13.1836 10.0825C12.9438 10.1819 12.7259 10.3275 12.5424 10.5111C12.3589 10.6947 12.2134 10.9127 12.1141 11.1525C12.0149 11.3924 11.9639 11.6494 11.964 11.909ZM18.735 10.9V0H20V10.9H18.735ZM17.468 10.892V0H18.112V10.892H17.468ZM8.36802 10.892V0H9.63302V10.892H8.36802ZM5.83602 10.892V0H7.10002V10.892H5.83602ZM0.171021 10.892V0H0.794021V10.892H0.171021ZM2.68202 8.892V0H3.94702V8.892H2.68202ZM14.961 7.892V0H16.849V7.892H14.961ZM12.787 7.892V0H14.052V7.892H12.787ZM10.898 7.892V0H12.164V7.892H10.898Z",
    fill: "#0D2EA1"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "download-icon",
    viewBox: "0 0 100 94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 71.4376C49.2784 71.4376 48.5356 71.1405 47.9838 70.5887L29.7537 52.3799C28.629 51.2551 28.629 49.4512 29.7537 48.3264C30.8785 47.2016 32.6824 47.2016 33.8072 48.3264L47.1349 61.6541V3.52591C47.1349 1.93423 48.4082 0.660889 49.9999 0.660889C51.5916 0.660889 52.865 1.93423 52.865 3.52591V61.6541L66.1714 48.3264C67.2962 47.2016 69.1001 47.2016 70.2249 48.3264C71.3497 49.4512 71.3497 51.2551 70.2249 52.3799L52.0161 70.5887C51.4643 71.1617 50.7215 71.4376 49.9999 71.4376ZM94.2699 48.7084C94.2699 47.1167 95.5433 45.8434 97.135 45.8434C98.7267 45.8434 100 47.138 100 48.7084V74.7695C100 84.9987 91.6808 93.3392 81.4304 93.3392H18.5696C8.34041 93.3392 0 85.02 0 74.7695V48.284C0 46.6923 1.27334 45.4189 2.86503 45.4189C4.45671 45.4189 5.73005 46.6923 5.73005 48.284V74.7695C5.73005 81.8366 11.4813 87.6091 18.5696 87.6091H81.4304C88.4975 87.6091 94.2699 81.8578 94.2699 74.7695V48.7084Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSprite);
export default __webpack_public_path__ + "static/media/svg-sprite.636529eb9aa9cd7b41eb396b693fc2f9.svg";
export { ForwardRef as ReactComponent };